var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_takeout"},[(_vm.typeMenu == 'alacarte')?_c('TypeALaCarte'):_vm._e(),(_vm.typeMenu == 'drink')?_c('TypeDrink'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }